import React, {useEffect, useState} from "react";
import CustomTable, {CustomTablePagination, useHiddenColumns} from "../Utils/Tables/CustomTable";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import *  as snackbarActions from "../../actions/snackbarActions";
import MainSnackbar from "../Utils/Snackbar/SmsSnackbar";
import axios from "axios";
import {config} from "../../Helpers/env";
import {logoutErrorMessage} from "../../Helpers/ErrorMessages";
import {dateConvert} from "../Utils/ConvertDate";
import {LoadingGif} from "../Utils/Loader";
import { history } from "../../Helpers/history";
import {CustomTableCell, MuiPaper, StickyHeadTable} from "../Utils/Tables/StickyHeaderTable";
import PageTitle from "../Utils/smsTitle";
import {SubHeader} from "../../Containers/SubHeader";
import {useDebounce} from "../Lab/useDebounce";
import {DoctorDateFilter, Progress} from "../DoctorsModule/WaitingList";
import {FinishedStatus, PendingStatus} from "../DoctorsModule/doctorStyles";
import {ReusableRouteTabs} from "../Utils/Dialogs/ReusableTabs";
import ReusableDialog from "../Utils/Dialogs/ReusableDialog";
import Form from "react-bootstrap/Form";
import Label from "../Utils/FormInputs/Label";
import {useEmergencyPatientCount} from "./hooks/useEmergencyPatientCount";


const headData = [
    {id: 'count', numeric: false, disablePadding: false, label: 'Sl.', hidden: false},
    {id: 'date', numeric: false, disablePadding: false, label: 'Date', hidden: false},
    {id: 'patient_number', numeric: false, disablePadding: false, label: 'Patient No.', hidden: false},
    {id: 'patient_name', numeric: false, disablePadding: false, label: 'Patient Name', hidden: false},
    {id: 'phone_no', numeric: false, disablePadding: false, label: 'Phone ', hidden: false},
    {id: 'kin_phone_no', numeric: false, disablePadding: false, label: 'NOK Phone', hidden: false},
    {id: 'doctor_name', numeric: false, disablePadding: false, label: 'Doctor Name', hidden: false},
    {id: 'visit_department', numeric: false, disablePadding: false, label: 'Visit Department', hidden: false},
    {id: 'status', numeric: false, disablePadding: false, label: 'Status', hidden: false},
    {id: 'action', numeric: false, disablePadding: true, label: 'Action', hidden: false},
];

const GynAndObsWaitingList = ({actions, snackbars}) => {

    const {emergency_count} = useEmergencyPatientCount(actions);

    const components = [
        {label: 'Active Patients',     path: '/gyn-and-obs-waiting-list'},
        {label: 'Missed Appointments', path: '/gyn-missed-appointments'},
        {label: 'Delivered Mothers',   path: '/gyn-delivered-mothers'},
        // {label: 'High Risk Mothers',   path: '/gyn-high-risk-mothers'},
        {label: 'Emergency Patients',  path: '/gyn-emergency-patients', badge: true, badge_count: emergency_count},
    ];

    const [date, setDate] = useState({start_date: dateConvert(), end_date: dateConvert()});
    const [searchValue, setSearchValue] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [data, setData] = useState({waitingList:[], loading:'idle', total:0});
    const [activePage, setActivePage] = useState(1)
    const [refreshKey, setRefreshKey] = useState(0)
    const [debouncedInputValue] = useDebounce(searchValue, 500)
    const [openEmergencyDialog, setOpenEmergencyDialog] = useState(false);
    const [emergencyReason, setEmergencyReason] = useState('');
    const [emergencyTarget, setEmergencyTarget] = useState(null);

    const user = JSON.parse(sessionStorage.getItem('user'));
    const userObj = !user ? {} : user;
    const token = !userObj.token ? [] : userObj.token;
    const _token = !token[1] ? {} : token[1];
    const user_roles_id = !_token.user_roles_id ? "" : _token.user_roles_id;

    const {loading, total, waitingList} = data;
    const {start_date, end_date} = date;

    useEffect(() => {
        const formData = new FormData();
        formData.append('search', debouncedInputValue);
        formData.append('start_date', start_date);
        formData.append('end_date', end_date);
        formData.append('per_page', rowsPerPage);
        setData({...data, loading: 'pending'})
        axios.post(`${config.smsUrl}/obgyn/queue/${activePage}`, formData).then(res => {
            const data = res.data;
            const dt = !data ? {} : data;
            const arr = dt.waiting_list ? dt.waiting_list : [];
            const total_count = dt.total_count ? dt.total_count : 0;
            const items = arr.map((item, index) => {
                const status = {
                    2: <PendingStatus>Pending</PendingStatus>,
                    3: <Progress>Treatment ongoing</Progress>,
                    4: <FinishedStatus>Complete</FinishedStatus>
                }
                const procedures = Array.isArray(item.procedure_names)
                    ? item.procedure_names.filter(Boolean).join(', ')
                    : (item.procedure_names || '');
                const baseAction = item.status === 2 ? (
                    <button type='button' className='btn btn-sm small-btn sms-info-btn'
                        onClick={() => handleTakeUp(item.visit_id, item.patient_number)}>
                        Take up
                    </button>
                ) : item.status === 3 ? (
                    <div style={{display: 'flex', gap: '6px'}}>
                        <button type='button' className='btn btn-sm small-btn sms-amber-btn'
                            onClick={() => history.push(`/gyn-and-obs-gynae-consultation/${item.patient_number}/${item.visit_id}/1`)}>
                            Continue
                        </button>
                        <button type='button' className='btn btn-sm small-btn sms-gray-btn'
                            onClick={() => handleEndVisit(item.visit_id)}>
                            End Visit
                        </button>
                    </div>
                ) : null;
                const emergencyButton = !item.anc_booking_id ? null : (
                    <label style={{display: 'flex', alignItems: 'center', gap: '4px', margin: 0, cursor: 'pointer', fontSize: '13px', color: '#c4495c'}}>
                        <input type='checkbox' checked={false} onChange={() => handleOpenEmergencyDialog(item)} />
                        Emergency
                    </label>
                );
                return{
                    ...item,
                    count: ((activePage - 1) * rowsPerPage) + index + 1,
                    date: item.begin_datetime,
                    patient_number: item.patient_number,
                    patient_name: `${!item.first_name ? "" : item.first_name} ${!item.last_name ? "" : item.last_name}`,
                    procedure_names: procedures,
                    status:status[item.status],
                    action : (baseAction || emergencyButton) ? (
                        <div style={{display: 'flex', gap: '6px', flexWrap: 'wrap'}}>
                            {baseAction}
                            {emergencyButton}
                        </div>
                    ) : null
                }
            });
            setData({...data, loading: 'success', waitingList: items, total: total_count});
        }).catch((err) => {
            setData({...data, loading: 'error'});
            logoutErrorMessage(err, null, actions);
        })
    }, [debouncedInputValue, activePage, rowsPerPage, start_date, end_date, refreshKey]);


    const handleEndVisit = (visit_id) => {
        const formData = new FormData();
        formData.append('visit_id', visit_id);
        formData.append('action', 'end');
        axios.post(`${config.smsUrl}/cvisit/complete_visit`, formData).then(() => {
            actions.snackbarActions.snackSuccess('Visit ended successfully');
            setRefreshKey(prev => prev + 1);
        }).catch((err) => {
            logoutErrorMessage(err, null, actions);
        });
    };

    const handleTakeUp = (visit_id, patient_number) => {
        const formData = new FormData();
        formData.append('visit_id', visit_id);
        axios.post(`${config.smsUrl}/cvisit/Update_visit_takeup_status`, formData).then(() => {
            history.push(`/gyn-and-obs-gynae-consultation/${patient_number}/${visit_id}/1`);
        }).catch((err) => {
            logoutErrorMessage(err, null, actions);
        });
    };

    const updateEmergencyStatus = (item, is_emergency, reason) => {
        axios.post(`${config.smsUrl}/obgyn/anc/booking/mark_emergency`, {
            id: item.anc_booking_id,
            is_emergency,
            emergency_reason: reason || null,
            user_roles_id
        }).then(() => {
            actions.snackbarActions.snackSuccess(is_emergency ? 'Patient marked as emergency' : 'Emergency status removed');
            setRefreshKey(prev => prev + 1);
        }).catch((err) => {
            logoutErrorMessage(err, null, actions);
        });
    };

    const handleOpenEmergencyDialog = (item) => {
        setEmergencyTarget(item);
        setEmergencyReason('');
        setOpenEmergencyDialog(true);
    };

    const handleCloseEmergencyDialog = () => {
        setOpenEmergencyDialog(false);
        setEmergencyTarget(null);
    };

    const handleChangeEmergencyReason = (event) => {
        setEmergencyReason(event.target.value);
    };

    const handleMarkEmergency = (event) => {
        event.preventDefault();
        updateEmergencyStatus(emergencyTarget, true, emergencyReason);
        setOpenEmergencyDialog(false);
        setEmergencyTarget(null);
    };

    const handleChangeDate = (event) => {
        const {value, name} = event.target;
        setDate({...date, [name]: value});
    };

    const handleSearch = (event) => {
        setSearchValue(event.target.value);
        setActivePage(1);
        setPage(0);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        setActivePage(newPage + 1);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
        setActivePage(1);
    };

    const handleChangeNextPage = (value) => {
        setActivePage(value);
    };

    const closeSnackbar = () => {
        actions.snackbarActions.hideSnackbar();
    };

    const {openBar, type, message} = snackbars;

    const isLoading = loading === 'pending';
    const isSuccess = loading === 'success';
    const isRejected = loading === 'error';

    const {headCells, all_hidden, handleAllHeadCells, handleHeadCells} = useHiddenColumns(headData);

    const pagination = (
        <CustomTablePagination
            colSpan={3}
            activePage={activePage}
            page={page}
            rowsPerPage={rowsPerPage}
            count={total}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            isTotalCount
        />
    );

    return (
        <div data-testid="gyn-and-obs-waiting-list" className='journals'>
            <PageTitle title='Gyn and Obs Waiting List'/>
            <SubHeader title="Gyn and Obs" subTitle='Gyn and Obs Waiting List'>
                <div className="header-icon-margin-right-zero">
                    <img src="/images/antenatal-blue.png"
                         className="icon-resize surgery-icon-tabs ante-natal-green"/>
                </div>
            </SubHeader>
            <ReusableRouteTabs value={history.location.pathname} tabHeading={components}/>

            <ReusableDialog message='Mark Patient as Emergency' openDialog={openEmergencyDialog} handleClose={handleCloseEmergencyDialog}
                handleSubmit={handleMarkEmergency} width='sm'>
                    <div className="my-2">
                        <Form.Group>
                            <Label name="Reason (optional)"/>
                            <Form.Control as="textarea" rows={3} value={emergencyReason} onChange={handleChangeEmergencyReason}
                                placeholder="e.g. severe bleeding, hypertension, obstructed labor"/>
                        </Form.Group>
                    </div>
            </ReusableDialog>

            <div className="mui-tables">
                <div className="row mb-0">
                    <div className="col-lg-8">
                        <DoctorDateFilter {...{state: date, handleChange: handleChangeDate}}/>
                    </div>
                </div>
                <MainSnackbar variant={type} open={openBar} message={message} handleCloseBar={closeSnackbar}/>
                <CustomTable title="Gyn and Obs Waiting List" customPage
                             handleChangeNextPage={handleChangeNextPage}
                             headData={headCells} handler={handleSearch} records={10} total_count={total}
                             activePage={activePage} data={waitingList} colSpan={5} term={searchValue}
                             handleHeadCells={handleHeadCells} all_hidden={all_hidden}
                             handleAllHeadCells={handleAllHeadCells} pagination={pagination}>
                    <TableBody>
                        {isLoading ? <TableRow>
                            <TableCell colSpan={headCells.length} align="center">
                                <img src="/images/smsloader.gif" alt="loader"/>
                            </TableCell>
                        </TableRow> : null}
                        {isSuccess ? waitingList.length > 0 ? waitingList.slice(0, rowsPerPage)
                            .map((item, index) => (
                                <TableRow hover role="checkbox" tabIndex={-1}
                                          key={index} className='mui-table-row'>
                                    {headCells.map((head) => (
                                        <TableCell key={head.id}
                                                   hidden={head.hidden}>{item[head.id]}</TableCell>
                                    ))}
                                </TableRow>
                            )) : <TableRow>
                            <TableCell colSpan={headCells.length} align="center">No records found</TableCell>
                        </TableRow> : null}
                        {isRejected ? <TableRow>
                            <TableCell colSpan={headCells.length} align="center">The server did not return a
                                valid response</TableCell>
                        </TableRow> : null}
                    </TableBody>
                </CustomTable>
            </div>
        </div>
    );
};

function mapStateToProps(state) {
    return {snackbars: state.snackbar};
}

function mapDispatchToProps(dispatch) {
    return {actions: {snackbarActions: bindActionCreators(snackbarActions, dispatch)}};
}

export default connect(mapStateToProps, mapDispatchToProps)(GynAndObsWaitingList);